module.exports = __webpack_public_path__ + "static/publicity-e0fab9f67a6643eacfd5a041a10f5513.png";